'use client'

import { Text } from '@macarongfactory/web-ui'

import RankChips from './RankChips'
import {
  MODOOCAR_CODE,
  useModoocarImpression,
  useModoocarTracking,
} from '../_features/modoocar'

import type { IModoocarDetail, TFuelType } from '../_features/modoocar'

interface ICompareRankSectionProps {
  detail: IModoocarDetail
  fuelType: TFuelType
}

const RANK_SUBSECTION_LABEL = '랭킹 순위'

const CompareRankSection = ({ detail, fuelType }: ICompareRankSectionProps) => {
  const {
    lowerModelName,
    satisfactionRank,
    efficiencyRank,
    fuelCostPercentile,
    segment,
  } = detail
  const { itemShow } = useModoocarTracking()
  const impressionRef = useModoocarImpression<HTMLDivElement>(() =>
    itemShow(MODOOCAR_CODE.MODEL_COMPARE, 'stat_chip', RANK_SUBSECTION_LABEL)
  )

  // [주의]: RankChips와 같은 조건이어야 합니다. 조건이 다르면 칩 없이 빈 섹션이 그려집니다.
  const hasAnyRank =
    Boolean(segment) &&
    (satisfactionRank > 0 || efficiencyRank > 0 || fuelCostPercentile > 0)
  if (!hasAnyRank) return null

  return (
    <div
      ref={impressionRef}
      className='flex flex-col gap-dimension-x4 px-dimension-x5 py-dimension-x6'
    >
      <div className='flex flex-col gap-dimension-x0-5'>
        <Text
          as='h2'
          variant='title-1-semibold'
          color='text-foreground-neutral-strong'
        >
          다른 차와 비교하면?
        </Text>
        <Text variant='body-2-medium' color='text-foreground-neutral-normal'>
          {lowerModelName} {RANK_SUBSECTION_LABEL}
        </Text>
      </div>
      <RankChips
        satisfactionRank={satisfactionRank}
        efficiencyRank={efficiencyRank}
        fuelCostPercentile={fuelCostPercentile}
        fuelType={fuelType}
        segment={segment}
        trackCode={MODOOCAR_CODE.MODEL_COMPARE}
      />
    </div>
  )
}

export default CompareRankSection
